// extracted by mini-css-extract-plugin
export default {"appLayout":"layout_appLayout__81L2l","main":"layout_main__EvaiD"};